import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Dashboard from './Dashboard';
import LoginSplash from './LoginSplash';
import { GetUser } from "./util/Helper";

const App = () => {
  const {isAuthenticated, isLoading } = useAuth0();

  var _content = <LoginSplash/>;

  if(GetUser() || isAuthenticated){
    _content = <Dashboard/>;
  }
  else if (isLoading) {
    _content = <div>Loading...</div>;
  }

  _content = <Dashboard/>;
  
  return (_content);
};

export default App;